import { Link } from 'react-router-dom';
import { buttonVariants } from '@playcastdotio/Shadcn';
import { invitationState } from '../../../api/stores/lobbyStores';
import clsx from 'clsx';

export const DisconnectedHost = () => {
  return (
    <div className='flex flex-col items-center justify-center gap-y-8'>
      <div className='grid-rows col-span-full mx-auto grid content-center justify-center gap-y-4 text-center lg:gap-y-8'>
        {/* <p className='row-auto text-lg italic my-0 mx-auto'>You've been invited to a playcast!</p> */}
        <h2 className='row-auto mt-4 text-2xl font-bold lg:text-3xl'>{invitationState.currentState.selectedInvite?.description}</h2>
        <p>Our servers had a hiccup.</p>
        <p>Sorry about that. Try refreshing the page to jump back in.</p>
      </div>
      <div>
        <Link
          to='https://pavilion.playcast.io'
          className={clsx(buttonVariants(), 'max-w-48 text-wrap py-8 text-center')}
          data-testid='host-your-own-session-button'
        >
          Host Your Own Session on Playcast.io
        </Link>
      </div>
    </div>
  );
};
